import * as DataStagingStep from 'src/dto/PipelineStep/DataStagingStep';

import { ColumnArithmeticOperationMethod } from './ColumnArithmeticOperationMethod';
import { ConcatenateColumnsMethod } from './ConcatenateColumnsMethod';
import { ReplaceColumnValueMethod } from './ReplaceColumnValueMethod';
import { ReplaceValueMethod } from './ReplaceValueMethod';
import { StripValueMethod } from './StripValueMethod';
import { ToBooleanMethod } from './ToBooleanMethod';
import { ToDateMethod } from './ToDateMethod';
import { ToFloatMethod } from './ToFloatMethod';
import { ToIntMethod } from './ToIntMethod';
import { ValueArithmeticOperationMethod } from './ValueArithmeticOperationMethod';
import { PivotColumnValuesMethod } from './PivotColumnValuesMethod';

export function MethodForm({
  fields,
  onChange,
}: {
  fields: DataStagingStep.TransformationParameters;
  onChange: (fields: DataStagingStep.TransformationParameters) => void;
}) {
  if (!fields) {
    return null;
  }

  switch (fields.method) {
    case DataStagingStep.TransformationParametersMethod.ToDate:
      return <ToDateMethod fields={fields} onUpdate={onChange} />;
    case DataStagingStep.TransformationParametersMethod.ToInt:
      return <ToIntMethod fields={fields} onUpdate={onChange} />;
    case DataStagingStep.TransformationParametersMethod.ToFloat:
      return <ToFloatMethod fields={fields} onUpdate={onChange} />;
    case DataStagingStep.TransformationParametersMethod.ToBoolean:
      return (
        <ToBooleanMethod
          fields={fields}
          onUpdate={({ fields: { defaultValue, forceType } }) => {
            onChange({
              ...fields,
              default: defaultValue == 'true',
              force_type: forceType,
            });
          }}
        />
      );
    case DataStagingStep.TransformationParametersMethod.StripValue:
      return <StripValueMethod fields={fields} onUpdate={onChange} />;
    case DataStagingStep.TransformationParametersMethod.ReplaceColumnValue:
      return <ReplaceColumnValueMethod fields={fields} onUpdate={onChange} />;
    case DataStagingStep.TransformationParametersMethod.ReplaceValue:
      return <ReplaceValueMethod fields={fields} onUpdate={onChange} />;
    case DataStagingStep.TransformationParametersMethod.ConcatenateColumns:
      return <ConcatenateColumnsMethod fields={fields} onUpdate={onChange} />;
    case DataStagingStep.TransformationParametersMethod.ValueArithmeticOperation:
      return <ValueArithmeticOperationMethod fields={fields} onUpdate={onChange} />;
    case DataStagingStep.TransformationParametersMethod.ColumnArithmeticOperation:
      return <ColumnArithmeticOperationMethod fields={fields} onUpdate={onChange} />;
    case DataStagingStep.TransformationParametersMethod.PivotColumnValues:
      return <PivotColumnValuesMethod fields={fields} onUpdate={onChange} />;
    default:
      return null;
  }
}
